module.exports = __webpack_public_path__ + "static/media/device-hub.a54622f3.svg";